import {useIntl} from 'react-intl';
import {Card} from 'react-bootstrap';
import Level3Title from '../../../app/common/components/title/Level3Title';
import {useGetRouterArp} from '../Hooks/RouterManager';
import ArpTable from './ArpTable';

interface ArpPageProps {
  routerId: string;
}

const ArpPage = ({routerId}: ArpPageProps): JSX.Element => {
  const intl = useIntl();
  const {data, isLoading, isError} = useGetRouterArp(routerId);

  return (
    <Card>
      <Card.Header>
        <Card.Title>
          <Level3Title title={intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.ARP'})} />
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <p className="text-muted">
          {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.ARP.DESCRIPTION'})}
        </p>
        {isError ? (
          <div className="alert alert-warning">
            {intl.formatMessage({id: 'CONFIGURATION.ROUTEUR.ERROR'})}
          </div>
        ) : (
          <ArpTable data={data ?? []} isLoading={isLoading} />
        )}
      </Card.Body>
    </Card>
  );
};

export default ArpPage;
